import React from 'react'
import Banner from "../component/banner";
import Process from "../component/process";
import Aboutour from "../component/Aboutour";
import Catagories from "../component/catagories";
import Animation from "../component/Lables";
import Template from "../component/Template";
import Feature from "../component/Feature";
import Feedback from "../component/Feedback";
import Logoslide from "../component/Logoslide";
import Post from "../component/Postmention";

function Home() {
  return (
    <>
      <Banner />
      <Process />
      <Aboutour />
      <Catagories />
      <Animation />
      <Template />
      <Feature />
      <Feedback />
      <Logoslide />
      <Post />
    
    </>
  )
}

export default Home